import { API_CODES } from "globals/constants";
import { buildSearchParams, request } from "utils/proxy";


export const classificationCodes = {
	/**
	 * Retrieve a list of classification codes.
	 *
	 * @param {{}} params - Query parameters for filtering and pagination.
	 * @param {string} params.search - A search term for filtering.
	 * @param {string} params.codeType - The type of code to retrieve.
	 * @param {{}?} options - Request options.
	 *
	 * @returns {Promise<{}[]>} A Promise that resolves with the list of organizations.
	 */
	findAll: (params, options) => {
		const { codeType: _codeType, ...queryParams } = params;
		const codeType = _codeType.toLowerCase();

		let path;
		switch (codeType) {
		case "herdc": {
			path = `${API_CODES}/herdc${buildSearchParams(queryParams)}`; break;
		}
		case "toa": {
			path = `${API_CODES}/toa${buildSearchParams(queryParams)}`; break;
		}
		default: {
			path = `${API_CODES}${buildSearchParams({ codeType, ...queryParams })}`;
		}
		}

		return request(path, options);
	},
};
